'use strict';


import { createOrbitToMapButton, hideOrbitToMapButton, showOrbitToMapButton } from '../../../controls/orbitControls';
import { TilesPluginCore } from './TilesPluginCore';

export class PanoramaToMapPlugin extends TilesPluginCore{
	constructor (panorama) {
		super('PanoramaToMapPlugin');
		
		this.panorama = panorama;
		this.camera = this.panorama.camera;
		createOrbitToMapButton();
		this.targetFov = this.panorama.config.fov.max;
	}
	
	update(frustum) {
		if (Math.round(this.camera.fov) === this.targetFov) {
			showOrbitToMapButton()
		} else {
			hideOrbitToMapButton();
		}
	}
	
}
